'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    QuantityProduct: {
        displayName: 'QuantityProduct'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/QuantityProduct/QuantityProduct.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var QuantityProduct = _wrapComponent('QuantityProduct')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang
    };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(QuantityProduct, _Component);

    function QuantityProduct() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, QuantityProduct);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuantityProduct.__proto__ || (0, _getPrototypeOf2.default)(QuantityProduct)).call.apply(_ref, [this].concat(args))), _this), _this.onClickPlus = function (event) {
            event.preventDefault();
            var currentValue = parseInt(_this.props.value, 10) || 0;
            _this.props.callback(currentValue + 1);
        }, _this.onClickMinus = function (event) {
            event.preventDefault();
            var currentValue = parseInt(_this.props.value, 10) || 0;
            if (currentValue > 1) {
                _this.props.callback(currentValue - 1);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    /**
     * @param event
     */


    (0, _createClass3.default)(QuantityProduct, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('QuantityProduct');

            return _react3.default.createElement(View, {
                onClickMinus: this.onClickMinus,
                onClickPlus: this.onClickPlus,
                checkValue: this.props.checkValue,
                checkCount: this.props.checkCount,
                value: this.props.value,
                lang: this.props.lang });
        }
    }]);
    return QuantityProduct;
}(_react2.Component), _class2.propTypes = {
    value: _react2.PropTypes.number.isRequired,
    callback: _react2.PropTypes.func.isRequired,
    checkValue: _react2.PropTypes.bool,
    checkCount: _react2.PropTypes.number,
    lang: _react2.PropTypes.object
}, _temp2)) || _class));

exports.default = QuantityProduct;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuantityProduct/QuantityProduct.jsx
// module id = 1742
// module chunks = 0